import React, { useEffect, useState } from "react";
import { getCoaching } from "@/lib/api";
import { PageHeader } from "@/components/dashboard/ui";
import { Play, Search } from "lucide-react";

export default function ResourcesApp() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { getCoaching().then(setList); }, []);
  const filtered = list.filter((c) => c.title.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="fade-in">
      <PageHeader title="Resources & Coaching Library" subtitle="On-demand lessons, masterclasses, and at-home guides" />
      <div className="flex items-center gap-2.5 rounded-2xl bg-white border border-slate-100 px-4 py-3 max-w-md mb-5 card-soft"><Search size={18} className="text-slate-400" /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search library…" className="flex-1 bg-transparent outline-none text-[14.5px]" /></div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
        {filtered.map((c) => (
          <div key={c.id} className="card-soft card-hover overflow-hidden cursor-pointer group">
            <div className="relative h-40"><img src={c.thumb} alt={c.title} className="w-full h-full object-cover" /><span className="absolute inset-0 grid place-items-center bg-black/20 group-hover:bg-black/30"><span className="h-12 w-12 rounded-full bg-white/90 grid place-items-center text-[#1a5fd0]"><Play size={20} className="fill-[#1a5fd0]" /></span></span></div>
            <div className="p-4"><div className="text-[14.5px] font-bold text-[#10233f] leading-tight">{c.title}</div><div className="text-[12.5px] text-slate-500 mt-1">{c.kind} · {c.duration}</div></div>
          </div>
        ))}
      </div>
    </div>
  );
}
